// extracted by mini-css-extract-plugin
export default {"discount-table":"DiscountsField_discount-table__ltIAM","disabled":"DiscountsField_disabled__vKr+R"};